// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"jut__ClickableCard__clickableCard","activeKeypress":"jut__ClickableCard__activeKeypress"};